export default __webpack_public_path__ + "static/media/plantsBox.82f5f038.png";